import React from 'react';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';
import { useNavigate, useLocation } from 'react-router-dom';

const BreadcrumbNavigation = ({ customBreadcrumbs = null }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Default breadcrumb mapping based on routes
  const routeMapping = {
    'dashboard': { label: 'Dashboard', icon: HomeIcon },
    'users': { label: 'Users', parent: 'dashboard' },
    'teams': { label: 'Teams', parent: 'dashboard' },
    'roles': { label: 'Roles & Permissions', parent: 'dashboard' },
    'domains': { label: 'Domains', parent: 'dashboard' },
    'email-settings': { label: 'Email Migration', parent: 'dashboard' },
    'storage': { label: 'Storage', parent: 'dashboard' },
    'reports': { label: 'Reports', parent: 'dashboard' },
    'settings': { label: 'Settings', parent: 'dashboard' },
    'support': { label: 'Support', parent: 'dashboard' },
    'billing': { label: 'Billing', parent: 'dashboard' },
    'invoices': { label: 'Invoices', parent: 'dashboard' },
    'license-management': { label: 'License Overview', parent: 'dashboard' },
    'mail-rules': { label: 'Mail Rules', parent: 'dashboard' },
    'erp-dashboard': { label: 'ERP Dashboard', parent: 'dashboard' },
    'erp-instances': { label: 'ERP Instances', parent: 'dashboard' },
    'erp-users': { label: 'ERP Users', parent: 'dashboard' },
    'erp-catalog': { label: 'ERP Catalog', parent: 'dashboard' },
    'ai-dashboard': { label: 'AI Dashboard', parent: 'dashboard' },
    'ai-agents': { label: 'AI Agents', parent: 'dashboard' },
    'voice': { label: 'Voice', parent: 'dashboard' },
  };

  const generateBreadcrumbs = () => {
    if (customBreadcrumbs) {
      return customBreadcrumbs;
    }

    const pathSegments = location.pathname.split('/').filter(Boolean);
    const currentPath = pathSegments[pathSegments.length - 1];
    const currentRoute = routeMapping[currentPath];

    if (!currentRoute) {
      return [{ label: 'Dashboard', path: '/dashboard', icon: HomeIcon }];
    }

    const breadcrumbs = [];
    
    // Always start with Dashboard
    breadcrumbs.push({ 
      label: 'Dashboard', 
      path: '/dashboard', 
      icon: HomeIcon,
      clickable: currentPath !== 'dashboard'
    });

    // Add current page if not dashboard
    if (currentPath !== 'dashboard') {
      breadcrumbs.push({
        label: currentRoute.label,
        path: location.pathname,
        clickable: false
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  return (
    <nav className="flex items-center space-x-1 text-sm text-gray-600 mb-4">
      {breadcrumbs.map((breadcrumb, index) => (
        <div key={index} className="flex items-center">
          {index > 0 && (
            <ChevronRightIcon className="w-3 h-3 text-gray-400 mx-1" />
          )}
          
          {breadcrumb.clickable ? (
            <button
              onClick={() => navigate(breadcrumb.path)}
              className="flex items-center space-x-1 hover:text-slate-700 transition-colors"
            >
              {breadcrumb.icon && (
                <breadcrumb.icon className="w-3 h-3" />
              )}
              <span>{breadcrumb.label}</span>
            </button>
          ) : (
            <div className="flex items-center space-x-1 text-gray-900 font-medium">
              {breadcrumb.icon && (
                <breadcrumb.icon className="w-3 h-3" />
              )}
              <span>{breadcrumb.label}</span>
            </div>
          )}
        </div>
      ))}
    </nav>
  );
};

export default BreadcrumbNavigation;